import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\PushSubscriptionController::status
 * @see app/Http/Controllers/PushSubscriptionController.php:35
 * @route '/push-subscription/status'
 */
export const status = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: '/push-subscription/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PushSubscriptionController::status
 * @see app/Http/Controllers/PushSubscriptionController.php:35
 * @route '/push-subscription/status'
 */
status.url = (options?: RouteQueryOptions) => {
    return status.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PushSubscriptionController::status
 * @see app/Http/Controllers/PushSubscriptionController.php:35
 * @route '/push-subscription/status'
 */
status.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PushSubscriptionController::status
 * @see app/Http/Controllers/PushSubscriptionController.php:35
 * @route '/push-subscription/status'
 */
status.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PushSubscriptionController::status
 * @see app/Http/Controllers/PushSubscriptionController.php:35
 * @route '/push-subscription/status'
 */
    const statusForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: status.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PushSubscriptionController::status
 * @see app/Http/Controllers/PushSubscriptionController.php:35
 * @route '/push-subscription/status'
 */
        statusForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: status.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PushSubscriptionController::status
 * @see app/Http/Controllers/PushSubscriptionController.php:35
 * @route '/push-subscription/status'
 */
        statusForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: status.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    status.form = statusForm
/**
* @see \App\Http\Controllers\PushSubscriptionController::store
 * @see app/Http/Controllers/PushSubscriptionController.php:47
 * @route '/push-subscription'
 */
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/push-subscription',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PushSubscriptionController::store
 * @see app/Http/Controllers/PushSubscriptionController.php:47
 * @route '/push-subscription'
 */
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PushSubscriptionController::store
 * @see app/Http/Controllers/PushSubscriptionController.php:47
 * @route '/push-subscription'
 */
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\PushSubscriptionController::store
 * @see app/Http/Controllers/PushSubscriptionController.php:47
 * @route '/push-subscription'
 */
    const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: store.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\PushSubscriptionController::store
 * @see app/Http/Controllers/PushSubscriptionController.php:47
 * @route '/push-subscription'
 */
        storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: store.url(options),
            method: 'post',
        })
    
    store.form = storeForm
/**
* @see \App\Http\Controllers\PushSubscriptionController::destroy
 * @see app/Http/Controllers/PushSubscriptionController.php:97
 * @route '/push-subscription'
 */
export const destroy = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/push-subscription',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\PushSubscriptionController::destroy
 * @see app/Http/Controllers/PushSubscriptionController.php:97
 * @route '/push-subscription'
 */
destroy.url = (options?: RouteQueryOptions) => {
    return destroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PushSubscriptionController::destroy
 * @see app/Http/Controllers/PushSubscriptionController.php:97
 * @route '/push-subscription'
 */
destroy.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

    /**
* @see \App\Http\Controllers\PushSubscriptionController::destroy
 * @see app/Http/Controllers/PushSubscriptionController.php:97
 * @route '/push-subscription'
 */
    const destroyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: destroy.url({
                    [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                        _method: 'DELETE',
                        ...(options?.query ?? options?.mergeQuery ?? {}),
                    }
                }),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\PushSubscriptionController::destroy
 * @see app/Http/Controllers/PushSubscriptionController.php:97
 * @route '/push-subscription'
 */
        destroyForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: destroy.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'DELETE',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'post',
        })
    
    destroy.form = destroyForm
const pushSubscription = {
    status: Object.assign(status, status),
store: Object.assign(store, store),
destroy: Object.assign(destroy, destroy),
}

export default pushSubscription